export default __webpack_public_path__ + "static/media/agustina.b9779e25.png";